import React from 'react';
import Utils from '../../lib/Utils';
import API from '../../lib/API';

class AssistForm extends React.Component {

  state = {

    yourname: this.props.data.username,
    finish_mail:this.props.data.email,
    finish_mail2:'',
    finish_mail3:'',
    school: this.props.data.school || this.props.data.albums[0].code,
    pageLength: 0,
    spreadType: 'full',
    cover: false,
    tobira: false,
    mine: false,
    mineLength: 0,
    minePhotoLimit: 0,
    size: 'A4',
    width: '',
    height: '',
    limitDate: '',
    bunrui: 'before',
    userType: 'customer',
    bikoh: '',
    tanto: '',
    
    yourname_validate_message:null,
    finish_mail_validate_message:null,
    finish_mail2_validate_message:null,
    limitDate_validate_message:null,
  }

  componentDidMount = () => {
    this.loadAlbumData(this.state.school);
  }

  getData = () => {
    let formData = {
      doc_date: (new Date()).toLocaleDateString('sv-SE'),
      yourname: this.state.yourname,
      customerName: this.props.data.customerName,
      finish_mail: this.state.finish_mail,
      finish_mail2: this.state.finish_mail2,
      finish_mail3: this.state.finish_mail3,
      albumName: this.props.data.albums.find(a=>a.code===this.state.school).hinmei,
      pageLength: this.state.pageLength,
      spreadType: this.state.spreadType,
      cover: this.state.cover,
      tobira: this.state.tobira,
      mineLength: this.state.mineLength,
      minePhotoLimit: this.state.minePhotoLimit,
      size: this.state.size,
      width: this.state.width,
      height: this.state.height,
      limitDate: this.state.limitDate,
      bunrui: this.state.bunrui,
      userType: this.state.userType,
      bikoh: this.state.bikoh,
      tanto: this.state.tanto,
      userId: this.state.school.replace(/(\d{2})$/, '-$1'),
    };
    return {
      schoolCode: this.state.school,
      hinmei: this.props.data.albums.find(a=>a.code===this.state.school).hinmei,
      filename: "アシスト申請_" + Utils.getHyphenationDate(),
      form: formData
    };
  }

  validation = () => {
    let newState = {};

    newState['yourname_validate_message'] = (()=>{
      if (this.state.yourname_validate_message === '') return '申請者のお名前を入力してください。';
      return null;
    })();
    newState['finish_mail_validate_message'] = (()=>{
      if (this.state.finish_mail !== '') {
        if (!this.state.finish_mail.match(/^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/)) return 'メールアドレスに誤りがあります。';
      }
      return null;
    })();
    newState['finish_mail2_validate_message'] = (()=>{
      if (this.state.finish_mail2 !== '') {
        if (!this.state.finish_mail2.match(/^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/)) return 'メールアドレスに誤りがあります。';
      }
      return null;
    })();

    newState['limitDate_validate_message'] = (()=>{
      if (this.state.limitDate === '') return 'アカウントの有効期限を設定してください。';
      else if (!this.state.limitDate.match(/^\d{4}-\d{2}-\d{2}$/)) return 'YYYY-MM-DDの形式で入力してください。';
      else if (this.state.limitDate < (new Date()).toLocaleDateString('sv-SE')) return '日付が過去の日付です。';
      return null;
    })();

    this.setState(newState);
    this.props.changeValidate(Object.values(newState).every(v=>v===null));
  }

  handleChangeValue = e => {
    let newState = {};
    newState[e.target.name] = e.target.value.trim();
    this.setState(newState, () =>{
      this.validation();
    });

    if (e.target.name === 'school') {
      this.loadAlbumData(e.target.value);
    }
  }

  loadAlbumData = (schoolCode) => {
    this.props.doLoading('アルバムデータの読み込み中');
    API.getAlbum(schoolCode).then(data=>{
      this.setState({
        size: data.info.size === 'A4' ? 'A4' : 'other',
        width: data.info.width,
        height: data.info.height,
        limitDate: data.info.expectedDate.replace(/^(\d{4})(\d{2})(\d{2})$/, '$1-$2-$3'),
        bunrui: (()=>{
          switch (data.info.s220) {
            case 1: return 'before';
            case 2: return 'after';
            case 3: return 'kinen';
            default: return '';
          }
        })(),
        tanto: data.info.tanto,
        finish_mail3: data.info.tantoEmail,
      });
      this.props.doLoading(null);
    });
  }

  handleMouseDownDatePicker = e => {
    let name = e.target.name;
    this.props.openDatePicker(e.target, value => {
      let newState = {};
      newState[name] = value;
      this.setState(newState, () =>{
        this.validation();
      });
    })
  }

  renderForm = () => {
    return (<form ref={ref=>{this.form=ref}}>

      <div className="formBlock titleBlock">
        <div className="titleBlock-wrap">
          <h2>アシストの申し込み</h2>
          <div>アルバム編集システムの申し込みフォームです。</div>
        </div>
      </div>

      <div className="formBlock">
        <div className="formBlock-title">対象の学校</div>
        <div className="formBlock-input">
          <select name="school" value={this.state.school} onChange={this.handleChangeValue}>{
            this.props.data.albums.map(a => {
              return <option key={a.code} value={a.code}>{a.hinmei}</option>
            })
          }</select>
        </div>
      </div>

      <div className="formBlock">
        <div className="formBlock-title">申請者お名前</div>
        <div className="formBlock-input">
          <input name="yourname" value={this.state.yourname} onChange={this.handleChangeValue}/>
        </div>
        {!this.state.yourname_validate_message?null
        :<div className="formBlock-error">{this.state.yourname_validate_message}</div>}
      </div>

      <div className="formBlock">
        <div className="formBlock-title">出稿通知メール 1</div>
        <div className="formBlock-input">
          <input name="finish_mail" type="mail" pattern="^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$" value={this.state.finish_mail} onChange={this.handleChangeValue}/>
        </div>
        {!this.state.finish_mail_validate_message?null
        :<div className="formBlock-error">{this.state.finish_mail_validate_message}</div>}
      </div>

      <div className="formBlock">
        <div className="formBlock-title">出稿通知メール 2</div>
        <div className="formBlock-input">
          <input name="finish_mail2" type="mail" pattern="^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$" value={this.state.finish_mail2} onChange={this.handleChangeValue}/>
        </div>
        {!this.state.finish_mail2_validate_message?null
        :<div className="formBlock-error">{this.state.finish_mail2_validate_message}</div>}
      </div>

      <div className="formBlock">
        <div className="formBlock-title">編集ページ数</div>
        <div className="formBlock-input">
          <input name="pageLength" type="number" step="2" min="0" max="100" value={this.state.pageLength} onChange={this.handleChangeValue}/>
        </div>
      </div>

      <div className="formBlock">
        <div className="formBlock-title">ページタイプ</div>
        <div className="formBlock-input">
          <div className="formBlock-checkbox">
            <label>
              <input name="spreadType" type="radio" value="full" checked={this.state.spreadType === 'full'} onChange={this.handleChangeValue}/>
              見開き
            </label>
          </div>
          <div className="formBlock-checkbox">
            <label>
              <input name="spreadType" type="radio" value="single" checked={this.state.spreadType === 'single'} onChange={this.handleChangeValue}/>
              単ページ
            </label>
          </div>
        </div>
      </div>

      <div className="formBlock">
        <div className="formBlock-title">その他のページ</div>
        <div className="formBlock-input">
          <div className="formBlock-checkbox">
            <label>
              <input name="cover" type="checkbox" value={this.state.cover !== 'true'} checked={this.state.cover === 'true'} onChange={this.handleChangeValue}/>
              表紙
            </label>
          </div>
          <div className="formBlock-checkbox">
            <label>
              <input name="tobira" type="checkbox" value={this.state.tobira !== 'true'} checked={this.state.tobira === 'true'} onChange={this.handleChangeValue}/>
              扉
            </label>
          </div>
          <div className="formBlock-checkbox">
            <label>
              <input name="mine" type="checkbox" value={this.state.mine !== 'true'} checked={this.state.mine === 'true'} onChange={this.handleChangeValue}/>
              MINE
            </label>
          </div>
          {this.state.mine !== 'true'?null
          : (<div className="formBlock">
            <div className="formBlock-title">MINEの編集</div>
            <div className="formBlock-input">
              <label>MINEの枚数</label>
              <input name="mineLength" type="number" step="1" min="0" max="100" value={this.state.mineLength} onChange={this.handleChangeValue}/>
              <label>写真点数</label>
              <input name="minePhotoLimit" type="number" step="1" min="0" max="4" value={this.state.minePhotoLimit} onChange={this.handleChangeValue}/>
            </div>
          </div>)
          }
        </div>
      </div>

      

      <div className="formBlock">
        <div className="formBlock-title">編集サイズ</div>
        <div className="formBlock-input">
          <div className="formBlock-checkbox">
            <label>
              <input name="size" type="radio" value="A4" checked={this.state.size === 'A4'} onChange={this.handleChangeValue}/>
              A4
            </label>
          </div>
          <div className="formBlock-checkbox">
            <label>
              <input name="size" type="radio" value="other" checked={this.state.size === 'other'} onChange={this.handleChangeValue}/>
              その他
            </label>
          </div>
          {this.state.size !== 'other'?null
          : (
            <div className="formBlock">
              <label>横（mm）</label>
              <div className="formBlock-input">
                <input name="width" type="number" step="1" min="100" max="1000" value={this.state.width} onChange={this.handleChangeValue} required pattern="^\d+$"/>
              </div>
  
              <label>縦（mm）</label>
              <div className="formBlock-input">
                <input name="height" type="number" step="1" min="100" max="1000" value={this.state.height} onChange={this.handleChangeValue} required pattern="^\d+$"/>
              </div>
            </div>)
          }
        </div>
      </div>


      <div className="formBlock">
        <div className="formBlock-title">アカウント有効期限</div>
        <div className="formBlock-input">
          <input name="limitDate" onMouseDown={this.handleMouseDownDatePicker} 
            value={this.state.limitDate} onChange={this.handleChangeValue} required pattern="^\d{4}-\d{2}-\d{2}$"/>
        </div>
        {!this.state.limitDate_validate_message?null
        :<div className="formBlock-error">{this.state.limitDate_validate_message}</div>}
      </div>


      <div className="formBlock">
        <div className="formBlock-title">編集作業者</div>
        <div className="formBlock-input">
          <div className="formBlock-checkbox">
            <label>
              <input name="userType" type="radio" value="customer" checked={this.state.userType === 'customer'} onChange={this.handleChangeValue}/>
              写真館
            </label>
          </div>
          <div className="formBlock-checkbox">
            <label>
              <input name="userType" type="radio" value="enduser" checked={this.state.userType === 'enduser'} onChange={this.handleChangeValue}/>
              生徒・保護者
            </label>
          </div>
          <div className="formBlock-checkbox">
            <label>
              <input name="userType" type="radio" value="test" checked={this.state.userType === 'test'} onChange={this.handleChangeValue}/>
              お試し用
            </label>
          </div>
        </div>
      </div>

      <div className="formBlock">
        <div className="formBlock-title">備考</div>
        <div className="formBlock-input">
          <textarea name="bikoh" value={this.state.bikoh} onChange={this.handleChangeValue}></textarea>
        </div>
      </div>



    </form>)
  }

  renderConfirm = () => {
    return (
      <div>
        <div className="formBlock titleBlock">
          <div className="titleBlock-wrap">
            <h2>アシストの申し込み</h2>
            <div>内容をよくご確認の上、ご申請ください。</div>
          </div>
        </div>
        <div className="confirm">
          <div className="confirm-row">
            <label>学校</label>
            <span>{this.props.data.albums.find(a=>a.code===this.state.school).hinmei}</span>
          </div>
          <div className="confirm-row">
            <label>申請者お名前</label>
            <span>{this.state.yourname}</span>
          </div>
          <div className="confirm-row">
            <label>出稿通知メール 1</label>
            <span>{this.state.finish_mail}</span>
          </div>
          <div className="confirm-row">
            <label>出稿通知メール 2</label>
            <span>{this.state.finish_mail2}</span>
          </div>
          <div className="confirm-row">
            <label>編集ページ数</label>
            <span>{this.state.pageLength}</span>
          </div>
          <div className="confirm-row">
            <label>ページタイプ</label>
            <span>{this.state.spreadType === 'single' ? '単ページ' : '見開き'}</span>
          </div>
          <div className="confirm-row">
            <label>表紙の編集</label>
            <span>{this.state.cover === 'true' ? 'あり' : 'なし'}</span>
          </div>
          <div className="confirm-row">
            <label>扉の編集</label>
            <span>{this.state.tobira === 'true' ? 'あり' : 'なし'}</span>
          </div>
          <div className="confirm-row">
            <label>MINEの編集枚数</label>
            <span>{this.state.mineLength}</span>
          </div>
          <div className="confirm-row">
            <label>MINEの写真点数</label>
            <span>{this.state.minePhotoLimit}</span>
          </div>
          <div className="confirm-row">
            <label>編集サイズ</label>
            <span>{
              this.state.size === 'A4' ? 'A4' : '横 '+this.state.width+'mm × 縦 '+this.state.height+'mm'
            }</span>
          </div>
          <div className="confirm-row">
            <label>アカウントの有効期限</label>
            <span>{this.state.limitDate}</span>
          </div>
          <div className="confirm-row">
            <label>編集作業者</label>
            <span>{(()=>{
              switch (this.state.userType) {
                case 'enduser': return '生徒・保護者';
                case 'test': return 'お試し用'
                default: return '写真館';
              }
            })()}</span>
          </div>
          <div className="confirm-row">
            <label>備考</label>
            <span>{this.state.bikoh}</span>
          </div>
          
        </div>
      </div>
    )
  }

  render () {
    switch (this.props.progress) {
      case 'form': return this.renderForm();
      case 'confirm': return this.renderConfirm();
      default: return null;
    }
  }
}
export default AssistForm;